<ws-modal-wrapper
    headerLabel="Addresses"
    (save)="save()"
    acceptLabel="OK"
    [hideSave]="!(canEdit || justSelect)"
    (cancel)="cancel()"
    [loading]="loading"
    [cancelLabel]="canEdit || justSelect ? 'Cancel' : 'Close'">
    <div class="modal-body exclude-modal-styling" style="padding: 35px 15px 5px 15px;">
        @if (!loading) {
            <div>
                @if (canEdit) {
                    <div class="ws-flex-none">
                        <button type="button"
                                class="ace-btn btn-sm btn-primary float-end"
                                (click)="addNew()"
                                helpTooltip
                                helpContentId="app.add"
                                position="bottom"
                                [disabled]="isEditing">Add Address
                        </button>
                    </div>
                }
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="text-align: center;">
                                @if(!justSelect){
                                    @if (defaultCheckboxHeaderOverride) {
                                        <span>{{ defaultCheckboxHeaderOverride }}</span>
                                    } @else {
                                        <span>Default</span>
                                    }
                                }
                            </th>
                            <th>Address</th>
                            <th>Correspondence</th>
                            <th>Remark</th>
                            @if (canEdit) {
                                <th></th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (entityAddress of entityAddresses; track entityAddress; let i = $index) {
                            @if (entityAddress.efAction !== 'delete') {
                                <tr (mouseenter)="entityAddress.isHovered = true"
                                    (mouseleave)="entityAddress.isHovered = false;">
                                    <td style="text-align: center;">
                                        <label style="width: 100%; min-height: 35px;">
                                            <input type="checkbox"
                                                [(ngModel)]="entityAddress.isDefault"
                                                (ngModelChange)="defaultSelected(entityAddress, i)"
                                                [disabled]="!canEdit  && !justSelect">
                                        </label>
                                    </td>
                                    <td>
                                        <address-view-edit [address]="entityAddress.address"
                                                        [isEditMode]="entityAddress.isEditMode"></address-view-edit>
                                    </td>
                                    <td>
                                        @if (!entityAddress.isEditMode) {
                                            <div>
                                                @for (
                                                    correspondence of entityAddress.entityAddressCorrespondences; track correspondence; let
                                                    last = $last) {
                                                    <span>{{ correspondence.correspondenceType.name }}@if (!last) {
                                                        <span>, </span>
                                                    }</span>
                                                }
                                            </div>
                                        }
                                        @if (entityAddress.isEditMode) {
                                            <div>
                                                @for (
                                                    correspondence of entityAddress.entityAddressCorrespondences; track correspondence; let
                                                    last = $last) {
                                                    <span class="label label-default"
                                                        style="margin-left: 5px; display: inline-block;"
                                                    >
                                                        {{ correspondence.correspondenceType.name }}
                                                        <i class="fa fa-close"
                                                        (click)="removeCorrespondence(correspondence, entityAddress)"
                                                        style="color: white; margin-left: 5px;"></i>
                                                    </span>
                                                }
                                                <div class="btn-group" dropdown style="display: block;">
                                                    <button dropdownToggle
                                                            type="button"
                                                            class="ace-btn btn-sm btn-secondary dropdown-toggle">
                                                        Add <span class="caret"></span>
                                                    </button>
                                                    <ul *dropdownMenu class="dropdown-menu" role="menu">
                                                        @for (
                                                            correspondenceType of entityAddress.correspondenceTypes; track correspondenceType) {
                                                            <li role="menuitem">
                                                                <a class="dropdown-item"
                                                                style="cursor: pointer;"
                                                                (click)="addCorrespondence(correspondenceType, entityAddress)">{{ correspondenceType.name }}</a>
                                                            </li>
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        }
                                    </td>
                                    <td>
                                        @if (!entityAddress.isEditMode) {
                                            <span style="word-break: break-word;">{{ entityAddress.remark }}</span>
                                        }
                                        @if (entityAddress.isEditMode) {
                                            <textarea type="text"
                                                    class="form-control"
                                                    [(ngModel)]="entityAddress.remark"
                                                    rows="7"
                                                    style="resize: none"></textarea>
                                        }
                                    </td>
                                    @if (canEdit) {
                                        <td style="white-space: nowrap;">
                                            @if (!entityAddress.isEditMode) {
                                                <div [class.invisible]="!entityAddress.isHovered || isEditing">
                                                    <button class="ace-btn has-icon btn-primary"
                                                            (click)="editEntityAddress(entityAddress)">
                                                        <i class="fa fa-pencil"></i></button>
                                                    @if (!entityAddress.isDefault && !justSelect) {
                                                        <button class="ace-btn has-icon btn-primary btn-danger"
                                                                (click)="entityAddress.efAction = 'delete'">
                                                            <i class="fa fa-trash"></i></button>
                                                    }
                                                </div>
                                            }
                                            @if (entityAddress.isEditMode) {
                                                <div>
                                                    <button class="ace-btn has-icon btn-primary btn-success"
                                                            (click)="update(entityAddress)">
                                                        <i class="fa fa-check"></i></button>
                                                    <button class="ace-btn has-icon btn-primary btn-danger"
                                                            (click)="cancelAddEdit(entityAddress)">
                                                        <i class="fa fa-close"></i></button>
                                                </div>
                                            }
                                        </td>
                                    }
                                </tr>
                            }
                        }
                    </tbody>
                </table>
            </div>
            @if (showBottomCheckBox) {
                <label>
                    <input type="checkbox"
                        [(ngModel)]="bottomCheckBox.value"
                        [disabled]="!canEdit && !justSelect">
                        {{ bottomCheckBox.text }}
                </label>
            }
        }

    </div>
</ws-modal-wrapper>
